import { Link } from 'react-router-dom';
import { articleClusters } from '@/mocks/articles';

const clusterImages: Record<string, string> = {
  'article-beginner': 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20fashion%20notes%20beside%20a%20warm%20cappuccino%20on%20rustic%20wooden%20cafe%20table%2C%20soft%20morning%20window%20light%2C%20cozy%20European%20coffee%20shop%20atmosphere%2C%20lifestyle%20editorial%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20no%20text%2C%20intimate%20and%20inviting&width=500&height=600&seq=article-beginner&orientation=portrait&nocache=true',
  'article-safety': 'https://readdy.ai/api/search-image?query=Protective%20packaging%20with%20delicate%20tissue%20paper%20and%20sealed%20box%20on%20clean%20white%20marble%20surface%2C%20bright%20airy%20studio%20light%2C%20modern%20minimal%20safety%20concept%2C%20professional%20editorial%20style%2C%20crisp%20clean%20composition%2C%20subtle%20sage%20green%20accents%2C%20no%20text&width=500&height=600&seq=article-safety&orientation=portrait&nocache=true',
  'article-comparison': 'https://readdy.ai/api/search-image?query=Two%20elegant%20product%20catalogs%20side%20by%20side%20with%20measuring%20tape%20between%20them%20on%20warm%20oak%20desk%2C%20soft%20afternoon%20light%20through%20venetian%20blinds%20creating%20stripe%20shadows%2C%20sophisticated%20comparison%20concept%2C%20editorial%20quality%2C%20warm%20cognac%20and%20ivory%20tones%2C%20no%20text&width=500&height=600&seq=article-comparison&orientation=portrait&nocache=true',
  'article-advanced': 'https://readdy.ai/api/search-image?query=Vintage%20brass%20magnifying%20glass%20over%20detailed%20product%20spreadsheet%20on%20dark%20walnut%20wood%20surface%2C%20warm%20pendant%20lamp%20light%20creating%20intimate%20glow%2C%20refined%20study%20aesthetic%2C%20scholarly%20editorial%20photography%2C%20rich%20deep%20brown%20and%20gold%20tones%2C%20no%20text&width=500&height=600&seq=article-advanced&orientation=portrait&nocache=true',
};

export default function ArticlesSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-12">
          <span className="text-xs font-heading italic text-accent-600">Content Hub</span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-2">
            Articoli e Guide
            <br />
            <span className="font-heading italic font-normal text-foreground-600">SEO 2026</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {articleClusters.map((cluster) => {
            const firstArticleSlug = cluster.articles[0]?.slug || '';
            return (
              <Link
                key={cluster.id}
                to={cluster.id === 'beginner' ? '/articoli/guida-completa-itaobuy-spreadsheet' : `/articoli/${firstArticleSlug}`}
                className="group cursor-pointer rounded-2xl overflow-hidden transition-all hover:scale-[1.02]"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={clusterImages[cluster.imageSeq]}
                    alt={cluster.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="bg-background-50 p-4">
                  <h3 className="text-base font-semibold text-foreground-900">{cluster.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{cluster.description}</p>
                  <div className="flex flex-wrap gap-1.5 mt-3">
                    {cluster.articles.map((article) => (
                      <span
                        key={article.slug}
                        className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
                      >
                        {article.title}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/articoli/guida-completa-itaobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium rounded-full bg-secondary-100 text-foreground-700 hover:bg-secondary-200 transition-colors cursor-pointer"
          >
            Leggi tutte le guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}